import { reactQueryClient } from '../../../web/ReactQueryProvider';
import { ITimeEntryFilter, ITimeEntryReviewQueueScope } from './types';

const BASE_QUERY_KEY = 'TimeEntry';

export const timeEntryKeys = {
	all: [BASE_QUERY_KEY] as const,
	day: (day: string) => [BASE_QUERY_KEY, 'day', day] as const,
	overdue: () => [BASE_QUERY_KEY, 'overdue'] as const,
	reviewQueue: (scope: ITimeEntryReviewQueueScope = {}) =>
		scope.managerUserId || scope.userId
			? ([BASE_QUERY_KEY, 'reviewQueue', scope] as const)
			: ([BASE_QUERY_KEY, 'reviewQueue'] as const),
	missing: (managerUserId?: string) =>
		managerUserId ? ([BASE_QUERY_KEY, 'missing', managerUserId] as const) : ([BASE_QUERY_KEY, 'missing'] as const),
	filter: (filter: ITimeEntryFilter) => [BASE_QUERY_KEY, 'filter', filter] as const,
	filterOptions: (filter: ITimeEntryFilter) => [BASE_QUERY_KEY, 'filterOptions', filter] as const,
	history: (id: string) => [BASE_QUERY_KEY, 'history', id] as const,
};

export function invalidateTimeEntries() {
	return reactQueryClient.invalidateQueries({ queryKey: timeEntryKeys.all });
}
